import CartBase from "./components/Base";

export default function CartFeature() {
  return (
    <div className="min-h-screen ">
      <CartBase />
    </div>
  );
}
